webpackJsonp([4,6],{

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createApi;

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _ciNetwork = __webpack_require__(166);

var _ciNetwork2 = _interopRequireDefault(_ciNetwork);

var _store = __webpack_require__(32);

var _store2 = _interopRequireDefault(_store);

var _devConsts = __webpack_require__(34);

var _devConsts2 = _interopRequireDefault(_devConsts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DOMAIN =  false ? _devConsts2.default.DEV_DOMAIN : '/';

_vue2.default.use(_ciNetwork2.default);

function createParams(params) {
  if (params.appkey && params.channel) var appkey = params.appkey,
        channel = params.channel;else if (_store2.default.state.user.userInfo) {
    appkey = _store2.default.state.user.userInfo.appkey;
    channel = _store2.default.state.user.userInfo.channel;
  } else {
    appkey = _devConsts2.default.DEV_USER_INFO.appkey;
    channel = _devConsts2.default.DEV_USER_INFO.channel;
  }
  if (!params.appkey && !params.channel) {
    params.appkey = appkey;
    params.channel = channel;
  }

  return params;
}

function createApi(url, params) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return _ciNetwork2.default.createApi('' + DOMAIN + url, createParams(params), option);
}

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var API_TOKEN = exports.API_TOKEN = '41rakznlmnggpw9ohu88b3hz13hd1scy';

var START_FETCH = exports.START_FETCH = 'START_FETCH';
var END_FETCH = exports.END_FETCH = 'END_FETCH';

var LOGIN = exports.LOGIN = 'LOGIN';
var LOGIN_OUT = exports.LOGIN_OUT = 'LOGIN_OUT';
var SET_ACCESS = exports.SET_ACCESS = 'SET_ACCESS';

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  hello: {
    title: 'welcome to your vue.js app',
    languageBtn: 'change language',
    themeBtn: 'change theme'
  },
  nav: {
    title: 'dashboard',
    home: 'home',
    components: 'components',
    example: 'example',
    noAccess: 'noAccess',
    user: 'user'
  }
};

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  hello: {
    title: '欢迎来到你的vue.js app',
    languageBtn: '切换语言',
    themeBtn: '切换主题'
  },
  nav: {
    title: '我的控制台',
    home: '主页',
    components: '组件',
    example: '实例',
    noAccess: '无权限',
    user: '用户'
  }
};

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var plugin = function plugin(store) {
  if (false) return;
  store.subscribe(function (mutation, state) {
    console.log(mutation);
  });
};

exports.default = plugin;

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(162);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(56);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(55);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _mutations;

var _consts = __webpack_require__(139);

var _apis = __webpack_require__(97);

var _devConsts = __webpack_require__(34);

var _devConsts2 = _interopRequireDefault(_devConsts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  userInfo: null,
  isLogin: false,
  hasAccess: false,
  isMaster: false };

var login = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var _state$userInfo, permissions, admins, _ref3, data, aclID, _permissions;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!state.userInfo) {
              _context.next = 7;
              break;
            }

            if (!state.isMaster) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return');

          case 3:
            _state$userInfo = state.userInfo, permissions = _state$userInfo.permissions, admins = _state$userInfo.admins;

            if (permissions && permissions.indexOf(params.page_name) > -1 || admins && admins.indexOf(_devConsts2.default.SERVICE_NAME) > -1) commit(_consts.SET_ACCESS, true);else commit(_consts.SET_ACCESS, false);
            _context.next = 20;
            break;

          case 7:
            _context.prev = 7;
            _context.next = 10;
            return (0, _apis.fetchLogin)(params);

          case 10:
            _ref3 = _context.sent;
            data = _ref3.data;
            aclID = data.acl_id, _permissions = data.permissions;

            if (aclID) {
              if (_permissions && _permissions.indexOf(params.page_name) > -1) commit(_consts.SET_ACCESS, true);else commit(_consts.SET_ACCESS, false);
            }
            commit(_consts.LOGIN, data);
            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context['catch'](7);

            commit(_consts.LOGIN_OUT);

          case 20:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[7, 17]]);
  }));

  return function login(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var actions = {
  login: login
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _consts.LOGIN, function (state, userinfo) {
  state.userInfo = userinfo;
  if (!userinfo.acl_id) {
    state.hasAccess = true;
    state.isMaster = true;
  }
  state.isLogin = true;
}), (0, _defineProperty3.default)(_mutations, _consts.SET_ACCESS, function (state, bool) {
  state.hasAccess = bool;
}), (0, _defineProperty3.default)(_mutations, _consts.LOGIN_OUT, function (state) {
  state.isLogin = false;
  state.hasAccess = false;
  state.isMaster = false;
}), _mutations);

exports.default = {
  state: state,
  actions: actions,
  mutations: mutations
};

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _elementUi = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'col',
  props: (0, _extends3.default)({}, _elementUi.Col.props)
};

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'container'
};

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'content'
};

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'noAccess'
};

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'notFound'
};

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _elementUi = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'row',
  props: (0, _extends3.default)({}, _elementUi.Row.props)
};

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(65);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _elementUi = __webpack_require__(22);

var _utils = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PULL = 'pull-sidebar';
var PULL_BACK = 'pull-sidebar-back';

exports.default = {
  name: 'sidebar',

  components: [_elementUi.Menu],

  props: (0, _extends3.default)({

    data: {
      type: Array
    },

    titlename: {
      type: String
    }

  }, _elementUi.Menu.props),

  methods: {
    getIndex: function getIndex(index, subIndex) {
      return subIndex ? subIndex + 2 + '-' + (index + 1) : '' + (index + 2);
    },
    select: function select() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['select'].concat(args));
    },
    open: function open() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.$emit.apply(this, ['select'].concat(args));
    },
    close: function close() {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      this.$emit.apply(this, ['close'].concat(args));
    },
    getLink: function getLink(link) {
      var routeQuery = this.$route.query;
      var query = link.indexOf('?') > -1 ? '&' : '?';
      (0, _keys2.default)(routeQuery).forEach(function (key) {
        query += key + '=' + routeQuery[key] + '&';
      });
      query = query.substring(0, query.length - 1);
      return query ? link + query : link;
    },
    startRouter: function startRouter(item) {
      if (!this.$router || !this.$route) throw new Error('请使用Vue Router');
      if (item.hash) {
        this.$router.push({
          path: item.hash,
          query: this.$route.query
        });
      } else if (item.name) {
        this.$router.push({
          name: item.name,
          query: this.$route.query
        });
      } else if (item.link) {
        window.location.href = this.getLink(item.link);
      }
    },
    handleSidebar: function handleSidebar() {
      this.$nextTick(function () {
        var container = document.getElementsByClassName('ci-container')[0];
        if (!(0, _utils.hasClass)(container, PULL) && !(0, _utils.hasClass)(container, PULL_BACK)) {
          (0, _utils.addClass)(container, PULL_BACK);
        } else if ((0, _utils.hasClass)(container, PULL)) {
          (0, _utils.removeClass)(container, PULL);
          (0, _utils.addClass)(container, PULL_BACK);
        } else {
          (0, _utils.removeClass)(container, PULL_BACK);
          (0, _utils.addClass)(container, PULL);
        }
      });
    }
  },

  watch: {
    '$route': function $route() {
      var container = document.getElementsByClassName('ci-container')[0];
      if ((0, _utils.hasClass)(container, PULL_BACK)) {
        (0, _utils.removeClass)(container, PULL_BACK);
        (0, _utils.addClass)(container, PULL);
      }
    }
  }
};

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(65);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _elementUi = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VERTICAL = 'vertical';
var HORIZONTAL = 'horizontal';
var WINDOW_WIDTH = window.screen.width <= 980;

exports.default = {
  name: 'topbar',

  components: [_elementUi.Menu],

  props: (0, _extends3.default)({

    data: {
      type: Array
    },

    titlename: {
      type: String
    },

    username: {
      type: String
    }

  }, _elementUi.Menu.props),

  data: function data() {
    return {
      showMode: HORIZONTAL
    };
  },


  computed: {
    userMenuClass: function userMenuClass() {
      return {
        user: true,
        'pull-right': this.showMode === HORIZONTAL,
        'hide': this.showMode === HORIZONTAL && WINDOW_WIDTH
      };
    },
    menuContentClass: function menuContentClass() {
      return {
        content: true,
        'hide': this.showMode === HORIZONTAL && WINDOW_WIDTH
      };
    },
    handleMenuClass: function handleMenuClass() {
      return this.showMode === HORIZONTAL ? 'el-icon-menu' : 'el-icon-circle-cross';
    }
  },

  methods: {
    getIndex: function getIndex(index, subIndex) {
      var count = this.appname ? 2 : 1;
      return subIndex ? subIndex + count + '-' + (index + 1) : '' + (index + count);
    },
    select: function select() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['select'].concat(args));
    },
    open: function open() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.$emit.apply(this, ['select'].concat(args));
    },
    close: function close() {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      this.$emit.apply(this, ['close'].concat(args));
    },
    getLink: function getLink(link) {
      var routeQuery = this.$route.query;
      var query = link.indexOf('?') > -1 ? '&' : '?';
      (0, _keys2.default)(routeQuery).forEach(function (key) {
        query += key + '=' + routeQuery[key] + '&';
      });
      query = query.substring(0, query.length - 1);
      return query ? link + query : link;
    },
    startRouter: function startRouter(item) {
      this.checkRouter();
      if (item.hash) {
        this.$router.push({
          path: item.hash,
          query: this.$route.query
        });
      } else if (item.name) {
        this.$router.push({
          name: item.name,
          query: this.$route.query
        });
      } else if (item.link) {
        window.location.href = this.getLink(item.link);
      }
    },
    loginOut: function loginOut() {
      this.checkRouter();
      var _$route$query$appkey = this.$route.query.appkey,
          appkey = _$route$query$appkey === undefined ? '' : _$route$query$appkey;

      var loginoutUrl = '/account/main.php?action=logout.html';
      var redirect = encodeURIComponent('/site/main.php?action=index.html&appkey=' + appkey);
      window.location.href = loginoutUrl + '&appkey=' + appkey + '&redirect=' + redirect;
    },
    handleTopbar: function handleTopbar() {
      this.showMode = this.showMode === HORIZONTAL ? VERTICAL : HORIZONTAL;
    },
    checkRouter: function checkRouter() {
      if (!this.$router || !this.$route) throw new Error('Topbar 依赖Vue Router');
    }
  },

  watch: {
    '$route': function $route() {
      this.showMode = HORIZONTAL;
    }
  }

};

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'app',
  computed: {
    appname: function appname() {
      return this.$t('nav.title');
    },
    username: function username() {
      var user = this.$store.state.user.userInfo;
      return user ? user.nickname : this.$t('nav.user');
    },
    navData: function navData() {
      return [{
        title: this.$t('nav.home'),
        name: 'index' }, {
        title: this.$t('nav.components'),

        items: [{
          title: this.$t('nav.example'),
          hash: '/example' }]
      }, {
        title: this.$t('nav.noAccess'),
        name: 'noAccess'
      }, {
        title: '404',
        link: '/#/no.html' }];
    }
  }
};

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(163);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _map = __webpack_require__(159);

var _map2 = _interopRequireDefault(_map);

var _getIterator2 = __webpack_require__(64);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _index = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'hello',

  components: {},

  props: {},

  data: function data() {
    return {
      help: 'write in src/components/Hello.vue and save',
      linkList: [{ href: 'http://router.vuejs.org/', name: 'vue-router' }, { href: 'http://vuex.vuejs.org/', name: 'vuex' }, { href: 'http://vue-loader.vuejs.org/', name: 'vue-loader' }, { href: 'https://github.com/vuejs/awesome-vue', name: 'awesome-vue' }]
    };
  },

  computed: {
    titleText: function titleText() {
      return this.$t('hello.title');
    },
    languageBtnText: function languageBtnText() {
      return this.$t('hello.languageBtn');
    },
    themeBtnText: function themeBtnText() {
      return this.$t('hello.themeBtn');
    }
  },

  beforeCreate: function beforeCreate() {},
  created: function created() {},
  mounted: function mounted() {
    this.$nextTick(function (_) {});
  },
  beforeUpdate: function beforeUpdate() {},
  updated: function updated() {},
  activated: function activated() {},
  deactivated: function deactivated() {},
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {},

  methods: {
    changeLanguage: function changeLanguage() {
      this.$i18n.locale = this.$i18n.locale === 'zh' ? 'en' : 'zh';
    },
    changeTheme: function changeTheme() {
      this.$nextTick(function (_) {
        var THEME_ARR = ['light-blue', 'dark-blue', 'light-dark'];
        var topbar = document.getElementsByClassName('ci-topbar')[0];
        var sidebar = document.getElementsByClassName('ci-sidebar')[0];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(new _map2.default(THEME_ARR.map(function (item, i) {
            return [i, item];
          }))), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                index = _step$value[0],
                item = _step$value[1];

            if ((0, _index.hasClass)(topbar, item)) {
              var n = index === 0 ? index : index - 1;
              THEME_ARR.splice(n, 1);
              var num = Math.round(Math.random());
              (0, _index.removeClass)(topbar, item);
              (0, _index.removeClass)(sidebar, item);
              (0, _index.addClass)(topbar, THEME_ARR[num]);
              (0, _index.addClass)(sidebar, THEME_ARR[num]);
              return;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  },

  watch: {}

};

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(253),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(257),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(256),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(258),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(259),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(250),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(255),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(251),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(231)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(260),
  /* scopeId */
  "data-v-92426efa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(252),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 250:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', _vm._b({}, 'el-row', _vm.$props), [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', _vm._b({
    staticClass: "ci-topbar",
    attrs: {
      "mode": _vm.showMode
    },
    on: {
      "select": _vm.select,
      "open": _vm.open,
      "close": _vm.close
    }
  }, 'el-menu', _vm.$props), [(_vm.titlename) ? _c('el-menu-item', {
    staticClass: "ci-topbar__title",
    attrs: {
      "index": "1"
    }
  }, [_vm._v(_vm._s(_vm.titlename))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.menuContentClass
  }, [_vm._l((_vm.data), function(item, index) {
    return (_vm.data) ? [(item.items) ? _c('el-submenu', {
      attrs: {
        "index": _vm.getIndex(index)
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.icon
    }), _vm._v(_vm._s(item.title))]), _vm._v(" "), _vm._l((item.items), function(menuItem, menuIndex) {
      return [(menuItem.items) ? _c('el-menu-item-group', {
        attrs: {
          "title": menuItem.title
        }
      }, _vm._l((menuItem.items), function(subItem, subIndex) {
        return _c('a', {
          key: subIndex,
          on: {
            "click": function($event) {
              _vm.startRouter(subIndex)
            }
          }
        }, [_c('el-menu-item', {
          attrs: {
            "index": _vm.getIndex(subIndex, index)
          }
        }, [_c('i', {
          class: subItem.icon
        }), _vm._v("\n                  " + _vm._s(subItem.title) + "\n              ")])], 1)
      })) : _c('a', {
        on: {
          "click": function($event) {
            _vm.startRouter(menuItem)
          }
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": _vm.getIndex(menuIndex, index)
        }
      }, [_c('i', {
        class: menuItem.icon
      }), _vm._v("\n                " + _vm._s(menuItem.title) + "\n              ")])], 1)]
    })], 2) : _c('a', {
      on: {
        "click": function($event) {
          _vm.startRouter(item)
        }
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": _vm.getIndex(index)
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v("\n            " + _vm._s(item.title) + "\n          ")])], 1)] : _vm._e()
  })], 2), _vm._v(" "), (_vm.username) ? _c('el-submenu', {
    class: _vm.userMenuClass,
    attrs: {
      "index": ("" + (_vm.data.length + 1))
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.loginOut
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": ((_vm.data.length + 2) + "-1")
    }
  }, [_vm._v("登出")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.handleTopbar
    }
  }, [_c('el-menu-item', {
    staticClass: "ci-topbar__menu",
    attrs: {
      "index": ("" + (_vm.data.length + 2))
    }
  }, [_c('i', {
    class: _vm.handleMenuClass
  })])], 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ci-hello')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', _vm._b({}, 'el-col', _vm.$props), [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('ci-topbar', {
    staticClass: "light-blue",
    attrs: {
      "data": _vm.navData,
      "username": _vm.username,
      "titlename": _vm.appname
    }
  }), _vm._v(" "), _c('ci-container', [_c('ci-sidebar', {
    staticClass: "light-blue",
    attrs: {
      "data": _vm.navData,
      "titlename": _vm.appname
    }
  }), _vm._v(" "), _c('ci-content', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', _vm._b({
    staticClass: "ci-sidebar",
    attrs: {
      "mode": "vertical"
    },
    on: {
      "select": _vm.select,
      "open": _vm.open,
      "close": _vm.close
    }
  }, 'el-menu', _vm.$props), [_c('div', {
    staticClass: "ci-sidebar__content"
  }, [(_vm.titlename) ? _c('el-menu-item', {
    staticClass: "ci-sidebar__title",
    attrs: {
      "index": "1"
    }
  }, [_vm._v(_vm._s(_vm.titlename))]) : _vm._e(), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.handleSidebar
    }
  }, [_c('i', {
    staticClass: "ci-sidebar__affix"
  })]), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return (_vm.data) ? [(item.items) ? _c('el-submenu', {
      attrs: {
        "index": _vm.getIndex(index)
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.icon
    }), _vm._v(_vm._s(item.title))]), _vm._v(" "), _vm._l((item.items), function(menuItem, menuIndex) {
      return [(menuItem.items) ? _c('el-menu-item-group', {
        attrs: {
          "title": menuItem.title
        }
      }, _vm._l((menuItem.items), function(subItem, subIndex) {
        return _c('a', {
          key: subIndex,
          on: {
            "click": function($event) {
              _vm.startRouter(subIndex)
            }
          }
        }, [_c('el-menu-item', {
          attrs: {
            "index": _vm.getIndex(subIndex, index)
          }
        }, [_c('i', {
          class: subItem.icon
        }), _vm._v("\n                  " + _vm._s(subItem.title) + "\n              ")])], 1)
      })) : _c('a', {
        on: {
          "click": function($event) {
            _vm.startRouter(menuItem)
          }
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": _vm.getIndex(menuIndex, index)
        }
      }, [_c('i', {
        class: menuItem.icon
      }), _vm._v("\n                " + _vm._s(menuItem.title) + "\n              ")])], 1)]
    })], 2) : _c('a', {
      on: {
        "click": function($event) {
          _vm.startRouter(item)
        }
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": _vm.getIndex(index)
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v("\n            " + _vm._s(item.title) + "\n          ")])], 1)] : _vm._e()
  })], 2), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ci-content"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ci-container"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ci-alert"
  }, [_c('h1', [_vm._v("您没有权限访问这个界面")]), _vm._v(" "), _c('h1', [_vm._v("请联系管理员以获得此权限")])])
}]}

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ci-alert"
  }, [_c('h1', [_vm._v("404 NOT FOUND")])])
}]}

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(238)
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.titleText))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.changeLanguage
    }
  }, [_vm._v(_vm._s(_vm.languageBtnText))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.changeTheme
    }
  }, [_vm._v(_vm._s(_vm.themeBtnText))]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.help))]), _vm._v(" "), _c('ul', _vm._l((_vm.linkList), function(list) {
    return _c('li', [_c('a', {
      attrs: {
        "href": list.href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.name))])])
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(96);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(92);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(32);

var _store2 = _interopRequireDefault(_store);

var _i18n = __webpack_require__(91);

var _i18n2 = _interopRequireDefault(_i18n);

var _components = __webpack_require__(90);

var _components2 = _interopRequireDefault(_components);

var _ciComponents = __webpack_require__(93);

var _ciComponents2 = _interopRequireDefault(_ciComponents);

__webpack_require__(94);

__webpack_require__(95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_ciComponents2.default);

_components2.default.map(function (component) {
  _vue2.default.component('ci-' + component.name, component);
});

new _vue2.default({
  el: '#app',
  store: _store2.default,
  i18n: _i18n2.default,
  router: _router2.default,
  render: function render(h) {
    return h(_App2.default);
  },
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(263);

var _vuex2 = _interopRequireDefault(_vuex);

var _state = __webpack_require__(145);

var _state2 = _interopRequireDefault(_state);

var _actions = __webpack_require__(142);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(143);

var _mutations2 = _interopRequireDefault(_mutations);

var _user = __webpack_require__(146);

var _user2 = _interopRequireDefault(_user);

var _plugin = __webpack_require__(144);

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  plugins: [_plugin2.default],
  strict: "production" !== 'production',
  state: _state2.default,
  actions: _actions2.default,
  mutations: _mutations2.default,
  modules: {
    user: _user2.default
  }
});

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

/**
 * Created by luliangxiao on 16/12/24.
 */
module.exports = {
  SERVICE_NAME: '', // service name
  DEV_DOMAIN: 'http://idg-' + 'w11p3333 <applecatkay@gmail.com>' + '.tunnel.nibaguai.com/', // TO FILL IN YOUR DOMAIN
  DEV_USER_INFO: {
    appkey: 'rjtwfgeqm2ankhx91wcp3hkeycujiutl',
    channel: '1',
    account_id: 'dev',
    nickname: 'w11p3333 <applecatkay@gmail.com>'
  }
}


/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hello = __webpack_require__(248);

var _Hello2 = _interopRequireDefault(_Hello);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [_Hello2.default];

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueI18n = __webpack_require__(239);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _en = __webpack_require__(219);

var _en2 = _interopRequireDefault(_en);

var _zhCN = __webpack_require__(79);

var _zhCN2 = _interopRequireDefault(_zhCN);

var _zh = __webpack_require__(141);

var _zh2 = _interopRequireDefault(_zh);

var _en3 = __webpack_require__(140);

var _en4 = _interopRequireDefault(_en3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueI18n2.default);

exports.default = new _vueI18n2.default({
  locale: 'en',
  messages: {
    en: (0, _extends3.default)({}, _en4.default, _en2.default),
    zh: (0, _extends3.default)({}, _zh2.default, _zhCN2.default)
  }
});

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(56);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(55);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(261);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(32);

var _store2 = _interopRequireDefault(_store);

var _nprogress = __webpack_require__(232);

var _nprogress2 = _interopRequireDefault(_nprogress);

__webpack_require__(229);

var _index = __webpack_require__(249);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var example = function example(resolve) {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 267)).then(resolve);
};

var notFound = function notFound(resolve) {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 269)).then(resolve);
};
var noAccess = function noAccess(resolve) {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 268)).then(resolve);
};

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  routes: [{
    path: '/index',
    name: 'index',
    component: _index2.default
  }, {
    path: '/example',
    name: 'example',
    component: example
  }, {
    path: '/',
    redirect: '/index'
  }, {
    path: '/noAccess',
    name: 'noAccess',
    component: noAccess
  }, {
    path: '*',
    component: notFound
  }]
});

router.beforeEach(function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(to, from, next) {
    var LOGIN_URL, _to$query, appkey, channel, params, _store$state$user, hasAccess, isLogin;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            window.scroll(0, 0);

            if (!(to.path === from.path)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return');

          case 3:
            _nprogress2.default.start();
            if (!(to.matched.some(function (record) {
              return record.meta.requiresAuth;
            }) && "production" !== 'development')) {
              _context.next = 28;
              break;
            }

            LOGIN_URL = '/site/main.php?action=index.html';
            _to$query = to.query, appkey = _to$query.appkey, channel = _to$query.channel;
            _context.prev = 7;

            if (!(appkey === undefined || channel === undefined)) {
              _context.next = 10;
              break;
            }

            throw new Error('参数缺失');

          case 10:
            params = { appkey: appkey, channel: channel, page_name: to.path };
            _context.next = 13;
            return _store2.default.dispatch('login', params);

          case 13:
            _store$state$user = _store2.default.state.user, hasAccess = _store$state$user.hasAccess, isLogin = _store$state$user.isLogin;

            console.log('\u5F53\u524D\u7528\u6237\u767B\u5F55\u72B6\u6001\u4E3A\u5DF2\u767B\u5F55: ' + isLogin + ' \u62E5\u6709\u6743\u9650: ' + hasAccess);

            if (isLogin) {
              _context.next = 19;
              break;
            }

            throw new Error('登录失败');

          case 19:
            if (!hasAccess) next({ name: 'noAccess', query: { appkey: appkey, channel: channel } });else next();

          case 20:
            _context.next = 26;
            break;

          case 22:
            _context.prev = 22;
            _context.t0 = _context['catch'](7);

            console.log(_context.t0);
            window.location.href = LOGIN_URL + '&appkey=' + appkey;

          case 26:
            _context.next = 29;
            break;

          case 28:
            next();

          case 29:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[7, 22]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

router.afterEach(function (_) {
  _nprogress2.default.done();
});

exports.default = router;

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(230)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(254),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLogin = fetchLogin;

var _network = __webpack_require__(138);

var _network2 = _interopRequireDefault(_network);

var _devConsts = __webpack_require__(34);

var _devConsts2 = _interopRequireDefault(_devConsts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchLogin(_ref) {
  var appkey = _ref.appkey,
      channel = _ref.channel,
      page_name = _ref.page_name;

  return (0, _network2.default)('topbar/main.php/json/login/check', {
    appkey: appkey,
    channel: channel,
    service_name: _devConsts2.default.SERVICE_NAME,
    page_name: page_name
  });
}

/***/ })

},[264]);


// WEBPACK FOOTER //
// static/js/app.74997710e171c8a0d756.js